// removed by extract-text-webpack-plugin
module.exports = {"table":"body__table__V4ds0","placeHolderRow":"body__placeHolderRow__HUmt9","placeHolderCell":"body__placeHolderCell__2NBbp","elementPlaceHolder":"body__elementPlaceHolder__1_-5t"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DataTable/Body/body.css
// module id = 784
// module chunks = 0